import {addParametersToEndpoint, APIRequestParameters, request} from "../../common/utils/apiHelpers";
import {AxiosPromise} from "axios";
import {StateResponse} from "./models";

export const requestState = (
    params: APIRequestParameters = {},
) : AxiosPromise<StateResponse> =>
    request(
        addParametersToEndpoint(`/state`, params),
    )